<template>
  <div></div>
</template>
<script>
export default {
  name: "CommonModuleCancelEnrollment",
  mounted() {
    let app = this
    app.routeToPlans();
  },
  computed: {
    isRepAuthenticated () {
      return this.$store.getters.isRepAuthenticated;
    },
    landingUrl () {
      return this.$store?.getters?.getLandingUrl
    }
  },
  methods: {
    routeToPlans() {
      let app = this
      if (app.isRepAuthenticated) {
        window.localStorage.removeItem('tempId');
        window.localStorage.removeItem('cartCount');
        app.$bus.$emit('resetCartInfo');
        if (app.landingUrl) {
          app.$router.push(`/${app.landingUrl}/plans`);
          window.location.reload();
        } else {
          app.$router.push(`/plans`);
          window.location.reload();
        }
      } else {
        app.$router.push('/404');
      }
    }
  }
}
</script>